import { AiReportChatMessage, AiReportResponse } from "@/model/models";
import apiClient from '@/utils/api-client'

export interface AiReportQueryParams {
    prompt: string
    dateFrom?: number
    dateTo?: number
    chartTypeHint?: string
    conversationHistory?: AiReportChatMessage[]
}


class AiReportService {
    public query(params: AiReportQueryParams) {
        return new Promise<AiReportResponse>((resolve, reject) => {
            apiClient.post('/api/v1/admin/ai-reports/query', params).then((res) => {
                resolve(new AiReportResponse(res.data))
            }).catch((error) => {
                console.log(error)
                reject(error)
            })
        })
    }
}

export default new AiReportService()
